import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../../../../images/thoot.png';
import SiteFoot from '../../../../shared/components/footer/index';

class Welcome extends Component {
    componentDidMount () {
        document.title = "Welcome to Kerenor booking";
    }
    render () {
        return (
            <div className="sign-in">
                <div className="sign-in__container">
                    <div className="main-block welcome">
                        <div className="main-block__logo">
                            <Link to="/">
                                <img src={logo} alt="Kerenor Booking"  width="300"/>
                            </Link>
                        </div>
                        <div className="main-block__buttons">
                            <Link to="/registration" className="btn btn-primary">Register</Link>&nbsp;
                            <Link to="/sign-in" className="btn btn-secondary">Sign In</Link>
                        </div>
                        <SiteFoot className="copyright"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Welcome/index.js